<template>
  <DsShowcase title="TextEditorPlay" description="Editor de texto rico (TipTap). Suporta bold, italic, listas, headings e mais.">
    <!-- Uso básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>v-model: string</code> — HTML do conteúdo</p>
      <div class="tw:max-w-2xl tw:space-y-3">
        <TextEditorPlay v-model="content1" />
        <details class="tw:text-xs">
          <summary class="tw:opacity-50 tw:cursor-pointer">Ver HTML gerado</summary>
          <pre class="tw:mt-2 tw:p-2 tw:bg-gray-100 tw:rounded tw:overflow-x-auto tw:text-[10px]">{{ content1 }}</pre>
        </details>
      </div>
    </section>

    <!-- Com conteúdo inicial -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Com conteúdo pré-preenchido</h2>
      <div class="tw:max-w-2xl">
        <TextEditorPlay v-model="content2" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { TextEditorPlay } from '@/components/atomic'

const content1 = ref('')
const content2 = ref('<h2>Título do conteúdo</h2><p>Texto com <strong>negrito</strong> e <em>itálico</em>.</p><ul><li>Item 1</li><li>Item 2</li></ul>')
</script>
